import {
	getClientCookie,
	removeClientCookie,
	setClientCookie,
} from '@app/utils/cookies';

const LOGIN_PARAMS = ['email'] as const;
type LoginKeys = (typeof LOGIN_PARAMS)[number];
type LoginParams = Partial<Record<LoginKeys, string>>;

const REGISTER_PARAMS = ['email', 'username', 'identity'] as const;
type RegisterKeys = (typeof REGISTER_PARAMS)[number];
type RegisterParams = Partial<Record<RegisterKeys, string>>;

const LOGIN_PREFILL_KEY = 'login_info';
const REG_PREFILL_KEY = 'reg_info';

export const setLoginPrefill = (params: LoginParams) => {
	setClientCookie(LOGIN_PREFILL_KEY, JSON.stringify(params));
};

export const removeLoginPrefill = () => {
	removeClientCookie(LOGIN_PREFILL_KEY);
};

// Get reg prefil from cookie in prio or query params as a fallback
export const getLoginPrefill = (): LoginParams | undefined => {
	// Client-side only
	if (!window || !location) return;
	const prefill = getClientCookie(LOGIN_PREFILL_KEY);

	if (prefill) {
		try {
			return JSON.parse(prefill);
		} catch {
			removeLoginPrefill();
			return undefined;
		}
	}

	const prefillFromQuery: LoginParams = {};
	const sp = new URLSearchParams(location.search);
	for (const key of LOGIN_PARAMS) {
		const value = sp.get(key);
		if (value) prefillFromQuery[key] = value;
	}
	return prefillFromQuery;
};

export const setRegisterPrefill = (params: RegisterParams) => {
	setClientCookie(REG_PREFILL_KEY, JSON.stringify(params));
};

export const removeRegisterPrefill = () => {
	removeClientCookie(REG_PREFILL_KEY);
};

// Get reg prefil from cookie in prio or query params as a fallback
export const getRegisterPrefill = (): RegisterParams | undefined => {
	// Client-side only
	if (!window || !location) return;
	const prefill = getClientCookie(REG_PREFILL_KEY);

	if (prefill) {
		try {
			return JSON.parse(prefill) as RegisterParams;
		} catch {
			removeRegisterPrefill();
			return undefined;
		}
	}

	const prefillFromQuery: RegisterParams = {};
	const sp = new URLSearchParams(location.search);
	for (const key of REGISTER_PARAMS) {
		const value = sp.get(key);
		if (value) prefillFromQuery[key] = value;
	}
	return prefillFromQuery;
};
